<template>
  <div class="leaderList">
    <heads></heads>

    <banners :pic="'pic1'"></banners>

    <div class="container">
      <div class="search-wrapper">
        <div class="search-input-wrapper">
          <input
            type="text"
            class="search-input"
            v-model="searchVal"
            @keyup.enter="toSearch"
            placeholder="请输入您想查找的内容"
          />
          <div class="search-btn" @click="tosearch">
            <span class="el-icon-search"></span>
            搜索
          </div>
        </div>
      </div>
      <div class="content" v-loading="loading">
        <div
          class="leaderlist"
          v-for="(item,index) in pageArray"
          :key="index"
          @click="toDetail(item.id)"
        >
          <div class="leaderitem">
            <img :src="item.headPicPath" class="left-img" />
            <div class="right-info">
              <div class="name">
                {{item.name}}
                <i
                  :class="['fa',item.gender.indexOf('female') !== -1 ? 'fa-venus' : 'fa-mars']"
                  aria-hidden="true"
                ></i>
              </div>
              <div class="evaluate">
                <span>带队{{item.leaderTotal}}次</span>
              </div>
            </div>
          </div>
          <!-- <div class="infoitem" v-html="item.memUnit"></div> -->
          <div class="infoitem">{{item.leaderAbstract}}</div>
        </div>
        <!-- <div class="chose-page">
          <el-pagination background layout="prev, pager, next" :total="1"></el-pagination>
        </div>-->
      </div>
      <div class="pagination">
        <el-pagination
          background
          layout="prev, pager, next"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="pageNumber"
          :page-size="10"
          :total="total"
        ></el-pagination>
      </div>
    </div>
    <homeFoots></homeFoots>
  </div>
</template>

<script>
import heads from "@/components/comment/heads.vue";
import homeFoots from "@/components/comment/homeFoots.vue";
import banners from "@/components/comment/banners.vue";

import axios from "axios";
export default {
  name: "leaderList",
  data() {
    return {
      pageNumber: 1,
      total: 0,
      searchVal: "",
      pageArray: "",
      loading: false,
    };
  },
  components: {
    heads,
    homeFoots,
    banners,
  },
  computed: {
    nav() {
      return this.$route.params.id;
    },
  },
  methods: {
    toDetail(id) {
      this.$router.push({ path: `/leaderDetail`, query: { id: id } });
    },
    handleCurrentChange(val) {
      this.getLeaderList();
    },
    handleSizeChange(val) {
      console.log("当前页:" + val);
    },
    tosearch() {
      this.getLeaderList();
    },
    getLeaderList() {
      const params = {
        pageNumber: this.pageNumber,
        pageSize: 10,
        name: this.searchVal,
      };

      axios
        .get(`/mobile/member/getLeaderList.jhtml`, {
          params,
        })
        .then((res) => {
          if (res.data.success) {
            this.pageArray = res.data.output.list;
            this.total = res.data.output.total;
            this.loading = false;
          }
        });
    },
  },
  mounted() {
    if (this.$route.query.search) {
      this.searchVal = this.$route.query.search;
    }
    this.loading = true;
    this.getLeaderList();
  },
  created() {},
};
</script>

<style scoped>
.activityIndex {
  width: 100%;
  height: 100%;

  /* text-align: left; */
}
.top-img {
  height: 400px;
}
.top-img > img {
  width: 100%;
  height: 100%;
}
.container {
  text-align: left;
  margin-bottom: 20px;
  margin-top: 20px;
}
.search-wrapper {
  width: 100%;
  /* position: absolute; */
  display: flex;
  justify-content: center;
  bottom: 0px;
  z-index: 9;
  box-sizing: border-box;
  color: #fff;
  font-size: 14px;
  padding: 20px 0;

  /* background: rgba(0, 0, 0, 0.38); */
}
.search-input-wrapper {
  display: flex;
  border-radius: 4px;
  padding: 5px;
  margin-top: 8px;
  position: relative;
  width: 800px;
}
.search-input {
  flex: 1;
  padding: 0 10px;
  /* border: 0; */
  border-radius: 4px;
  line-height: 45px;
  border: 1px solid #cccccc;
}
.search-btn {
  background: #007741;
  padding: 12px 25px;
  border-radius: 0 4px 4px 0;
  font-size: 16px;
  cursor: pointer;
  position: absolute;
  top: 5px;
  right: 5px;
}
.search-btn:hover {
  background: #05a35c;
}
.search-radio {
  position: absolute;
  right: 120px;
  top: 50%;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
}
.content {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;

  min-height: 350px;
}
.leaderlist {
  cursor: pointer;
  width: 45%;
  padding: 20px;
  box-shadow: 0px 0px 6px #c7c6c6;
  border-radius: 2px;
  margin-bottom: 20px;

  height: 140px;
}
.leaderlist:hover {
  background: #f5f5f5;
}
.chose-page {
  margin: 0 auto;
}
.leaderitem {
  display: flex;
  align-items: center;
}
.left-img {
  width: 80px;
  height: 80px;
  border-radius: 100%;
}
.right-info {
  height: 50px;
  line-height: 30px;
  margin-left: 20px;
  padding-left: 20px;
  border-left: 1px solid #999999;
}
.name {
  font-weight: bold;
  font-size: 17px;
}
.fa-mars {
  color: #0e79b1;
}
.fa-venus {
  color: #de4c4c;
}
.evaluate {
  display: flex;
}
.evaluate > span {
  font-size: 15px;
  width: 80px;
  color: #666666;
  line-height: 20px;
}
.evaluate > span:nth-child(2) {
  text-align: right;
  border-left: 1px solid #999999;
}
.infoitem {
  margin-top: 20px;
  color: #666666;
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;

  height: 40px;
}
.nac-active {
  color: #007741;
  font-weight: bold;
  border-bottom: 2px solid #007741;
}
</style>



// WEBPACK FOOTER //
// src/components/leaderview/leaderList.vue